import { useCallback } from "react";
import { useHistory } from 'react-router-dom';
import 'extensions/urlSearchParamsExtensions';

const useQueryParams = () => {
    const history = useHistory();

    const getQueryParamByName = useCallback((name) => {
        const { search } = history.location;

        const params = new URLSearchParams(search);

        return params.getIgnoreCase(name);

    }, [history.location])

    return {
        getQueryParamByName
    };
}

export default useQueryParams;